import { render, staticRenderFns } from "./ga_channel.vue?vue&type=template&id=288fe753&scoped=true"
import script from "./ga_channel.vue?vue&type=script&lang=js"
export * from "./ga_channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288fe753",
  null
  
)

export default component.exports